import * as types from '../mutation-types';
import { website } from '../../api';

const state = {
  websites: [],
  categories: [],
  zones: [],
};

const getters = {
};

const actions = {
  fetchWebsites({ commit }, params) {
    return website.get(params).then(({ data: response }) => {
      commit(types.RECEIVE_WEBSITES, { data: response, params });
    });
  },
  fetchWebsiteCategories({ commit }, zone) {
    return website.getCategories(zone).then(({ data: response }) => {
      commit(types.RECEIVE_WEBSITES_CATEGORIES, { data: response });
    });
  },
  fetchWebisteZone({ commit }) {
    return website.getWebisteZone().then(({ data: response }) => {
      commit(types.RECEIVE_WEBSITES_ZONES, { data: response });
    });
  },
};

/* eslint no-param-reassign: 0, default-case: 0 */
const mutations = {
  [types.RECEIVE_WEBSITES](s, { data }) {
    s.websites = [...data.data];
  },
  [types.RECEIVE_WEBSITES_CATEGORIES](s, { data }) {
    s.categories = data.data;
  },
  [types.RECEIVE_WEBSITES_ZONES](s, { data }) {
    s.zones = data.data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/website.js